<template>
    <div class="section pt-2 pb-5">
        <div class="section-title mal-text" style="font-size:16px;font-weight:800;color:#1a418c;margin-bottom:10px;">
            QHLS Final Exam Centers
        </div>

        <!-- Tabs -->
        <div style="display:flex;gap:8px;margin-bottom:14px;">
            <button @click="tab='centers'"
                :style="tabStyle(tab==='centers')" style="flex:1;padding:9px 0;border-radius:10px;border:none;font-size:13px;font-weight:700;cursor:pointer;">
                <ion-icon name="business-outline" style="margin-right:4px;"></ion-icon>
                Manage Centers
            </button>
            <button @click="switchToAssign()"
                :style="tabStyle(tab==='assign')" style="flex:1;padding:9px 0;border-radius:10px;border:none;font-size:13px;font-weight:700;cursor:pointer;">
                <ion-icon name="people-outline" style="margin-right:4px;"></ion-icon>
                Assign Candidates
            </button>
        </div>

        <!-- ===================== TAB: CENTERS ===================== -->
        <template v-if="tab==='centers'">
            <!-- Add form -->
            <div class="card p-3 mb-3" style="border-radius:12px;">
                <div style="font-size:13px;font-weight:700;color:#1a418c;margin-bottom:10px;" class="mal-text">പുതിയ സെന്റർ ചേർക്കുക</div>
                <label class="field-label">Centre Name *</label>
                <input v-model="newCenter.name" type="text" class="form-control form-control-sm mb-2" placeholder="Enter centre name" />
                <label class="field-label">Place</label>
                <input v-model="newCenter.location" type="text" class="form-control form-control-sm mb-2" placeholder="Enter place / location" />

                <!-- Coordinator -->
                <label class="field-label">Coordinator</label>
                <div style="position:relative;">
                    <input v-model="addCoordSearch" type="text" class="form-control form-control-sm mb-1"
                        :placeholder="newCenter.coordinator_name || 'Search by name or mobile...'"
                        @input="onPersonInput('coord','add')" @focus="addCoordDrop=true" autocomplete="off" />
                    <div v-if="addCoordDrop && addCoordResults.length"
                        style="position:absolute;left:0;right:0;top:100%;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,0.1);max-height:180px;overflow-y:auto;z-index:200;">
                        <div v-for="m in addCoordResults" :key="m.id" @click="selectPerson('coord','add',m)"
                            style="padding:10px 12px;cursor:pointer;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px;">
                            <ion-icon name="person-outline" style="color:#1a418c;font-size:15px;flex-shrink:0;"></ion-icon>
                            <div>
                                <div style="font-size:13px;font-weight:700;color:#1e293b;">{{ m.name }}</div>
                                <div style="font-size:11px;color:#64748b;">{{ m.mobile }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="newCenter.coordinator_name && !addCoordSearch"
                    style="background:#e8eeff;border-radius:8px;padding:6px 10px;margin-bottom:8px;display:flex;align-items:center;gap:8px;">
                    <ion-icon name="person-circle-outline" style="color:#1a418c;font-size:18px;"></ion-icon>
                    <div style="flex:1;">
                        <div style="font-size:13px;font-weight:700;color:#1a418c;">{{ newCenter.coordinator_name }}</div>
                        <div style="font-size:11px;color:#64748b;">{{ newCenter.coordinator_mobile }}</div>
                    </div>
                    <span @click="clearPerson('coord','add')" style="cursor:pointer;color:#94a3b8;font-size:16px;">✕</span>
                </div>
                <label class="field-label">Coordinator Mobile</label>
                <input v-model="newCenter.coordinator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <!-- Invigilator -->
                <label class="field-label">Invigilator</label>
                <div style="position:relative;">
                    <input v-model="addInvigSearch" type="text" class="form-control form-control-sm mb-1"
                        :placeholder="newCenter.invigilator_name || 'Search by name or mobile...'"
                        @input="onPersonInput('invig','add')" @focus="addInvigDrop=true" autocomplete="off" />
                    <div v-if="addInvigDrop && addInvigResults.length"
                        style="position:absolute;left:0;right:0;top:100%;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,0.1);max-height:180px;overflow-y:auto;z-index:200;">
                        <div v-for="m in addInvigResults" :key="m.id" @click="selectPerson('invig','add',m)"
                            style="padding:10px 12px;cursor:pointer;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px;">
                            <ion-icon name="person-outline" style="color:#1a418c;font-size:15px;flex-shrink:0;"></ion-icon>
                            <div>
                                <div style="font-size:13px;font-weight:700;color:#1e293b;">{{ m.name }}</div>
                                <div style="font-size:11px;color:#64748b;">{{ m.mobile }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="newCenter.invigilator_name && !addInvigSearch"
                    style="background:#e8f5e9;border-radius:8px;padding:6px 10px;margin-bottom:8px;display:flex;align-items:center;gap:8px;">
                    <ion-icon name="person-circle-outline" style="color:#2e7d32;font-size:18px;"></ion-icon>
                    <div style="flex:1;">
                        <div style="font-size:13px;font-weight:700;color:#2e7d32;">{{ newCenter.invigilator_name }}</div>
                        <div style="font-size:11px;color:#64748b;">{{ newCenter.invigilator_mobile }}</div>
                    </div>
                    <span @click="clearPerson('invig','add')" style="cursor:pointer;color:#94a3b8;font-size:16px;">✕</span>
                </div>
                <label class="field-label">Invigilator Mobile</label>
                <input v-model="newCenter.invigilator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <button @click="addCenter" :disabled="addingCenter || !newCenter.name.trim()"
                    class="btn btn-primary btn-sm w-100" style="border-radius:8px;">
                    <span v-if="addingCenter" class="spinner-border spinner-border-sm me-1"></span>
                    <ion-icon v-else name="add-circle-outline" class="me-1"></ion-icon>
                    Add Center
                </button>
            </div>

            <!-- Centers list -->
            <div v-if="loadingCenters" class="text-center py-3"><div class="spinner-border text-primary"></div></div>
            <div v-else-if="!centers.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">ഒരു സെന്ററും ചേർത്തിട്ടില്ല</div>
            <div v-else style="display:flex;flex-direction:column;gap:8px;">
                <div v-for="c in centers" :key="c.id" style="background:#fff;border-radius:12px;padding:12px 14px;border:1px solid #eef0f5;">
                    <div style="display:flex;align-items:flex-start;gap:8px;">
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:14px;font-weight:800;color:#1e293b;">{{ c.name }}</div>
                            <div v-if="c.location" style="font-size:12px;color:#64748b;margin-top:2px;">
                                <ion-icon name="location-outline" style="font-size:11px;"></ion-icon> {{ c.location }}
                            </div>
                            <div v-if="c.coordinator_name" style="font-size:12px;color:#1a418c;margin-top:3px;">
                                <ion-icon name="person-outline" style="font-size:11px;"></ion-icon>
                                {{ c.coordinator_name }}<span v-if="c.coordinator_mobile"> · {{ c.coordinator_mobile }}</span>
                            </div>
                            <div v-if="c.invigilator_name" style="font-size:12px;color:#2e7d32;margin-top:2px;">
                                <ion-icon name="eye-outline" style="font-size:11px;"></ion-icon>
                                {{ c.invigilator_name }}<span v-if="c.invigilator_mobile"> · {{ c.invigilator_mobile }}</span>
                            </div>
                        </div>
                        <!-- Actions -->
                        <div style="display:flex;flex-direction:column;gap:4px;flex-shrink:0;">
                            <button @click="openEdit(c)"
                                style="display:inline-flex;align-items:center;gap:4px;background:#e8eeff;border:none;border-radius:8px;padding:5px 10px;color:#1a418c;font-size:12px;font-weight:600;cursor:pointer;">
                                <ion-icon name="pencil-outline" style="font-size:13px;"></ion-icon> Edit
                            </button>
                            <button @click="deleteCenter(c)"
                                style="display:inline-flex;align-items:center;gap:4px;background:#fff0f0;border:none;border-radius:8px;padding:5px 10px;color:#e74c3c;font-size:12px;font-weight:600;cursor:pointer;">
                                <ion-icon name="trash-outline" style="font-size:13px;"></ion-icon> Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- ===================== TAB: ASSIGN ===================== -->
        <template v-if="tab==='assign'">
            <div v-if="user_level===1" class="card p-2 mb-2" style="border-radius:12px;">
                <div style="display:flex;flex-direction:column;gap:8px;">
                    <select v-model="f_district" class="form-select form-select-sm" @change="onFDistrictChange">
                        <option value="">All Districts</option>
                        <option v-for="d in districts" :key="d.id" :value="d.id">{{ d.name }}</option>
                    </select>
                    <select v-model="f_zone" class="form-select form-select-sm" @change="onFZoneChange">
                        <option value="">All Zones</option>
                        <option v-for="z in zones" :key="z.id" :value="z.id">{{ z.name }}</option>
                    </select>
                    <select v-model="f_center" class="form-select form-select-sm">
                        <option value="">All Centers</option>
                        <option v-for="c in qhlsCenters" :key="c.id" :value="c.id">{{ c.madrasa_name }}</option>
                    </select>
                    <button @click="loadQualified" class="btn btn-primary btn-sm" style="border-radius:8px;">
                        <span v-if="loadingQ" class="spinner-border spinner-border-sm me-1"></span>
                        <ion-icon v-else name="search-outline" class="me-1"></ion-icon> Search
                    </button>
                </div>
            </div>
            <div v-if="qualifiedLoaded" class="card mb-2" style="border-radius:12px;padding:10px 14px;background:#f0fff6;border:1px solid #b7f0d4;">
                <div style="display:flex;align-items:center;justify-content:space-between;">
                    <span style="font-size:13px;color:#1DCC70;font-weight:700;" class="mal-text">യോഗ്യർ (40+ മാർക്ക്)</span>
                    <span style="font-size:22px;font-weight:900;color:#1DCC70;">{{ qualified.length }}</span>
                </div>
            </div>
            <div v-if="loadingQ" class="text-center py-4"><div class="spinner-border text-primary"></div></div>
            <div v-else-if="qualifiedLoaded && !qualified.length" class="text-center text-muted py-3 mal-text" style="font-size:13px;">യോഗ്യരായ വിദ്യാർത്ഥികൾ ഇല്ല</div>
            <div v-else-if="qualified.length" style="display:flex;flex-direction:column;gap:8px;">
                <div v-for="(item, idx) in qualified" :key="item.registration_id"
                    style="background:#fff;border-radius:12px;padding:12px 14px;border:1px solid #eef0f5;">
                    <div style="display:flex;align-items:center;gap:10px;margin-bottom:8px;">
                        <div style="width:30px;height:30px;border-radius:50%;background:#1a418c;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                            <span style="color:#fff;font-size:11px;font-weight:800;">{{ idx+1 }}</span>
                        </div>
                        <div style="flex:1;min-width:0;">
                            <div style="font-size:14px;font-weight:800;color:#1e293b;">{{ item.name }}</div>
                            <div style="font-size:11px;color:#64748b;">{{ item.center_name || '—' }}<span v-if="item.zone_name"> · {{ item.zone_name }}</span></div>
                            <div v-if="item.mobile" style="font-size:11px;color:#64748b;margin-top:2px;">{{ item.mobile }}</div>
                        </div>
                        <div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;">
                            <div style="font-size:18px;font-weight:900;color:#1DCC70;">{{ item.effective_mark }}</div>
                            <div v-if="item.mobile" style="display:flex;gap:4px;">
                                <a :href="'https://wa.me/91' + item.mobile.replace(/\D/g,'')"
                                    target="_blank"
                                    style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:8px;background:#25D366;text-decoration:none;">
                                    <ion-icon name="logo-whatsapp" style="color:#fff;font-size:16px;"></ion-icon>
                                </a>
                                <a :href="'tel:' + item.mobile"
                                    style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:8px;background:#1a418c;text-decoration:none;">
                                    <ion-icon name="call-outline" style="color:#fff;font-size:16px;"></ion-icon>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div style="display:flex;align-items:center;gap:8px;">
                        <select v-model="item.final_center_id" class="form-select form-select-sm" style="flex:1;font-size:12px;" @change="assignCandidate(item)">
                            <option :value="null">— Assign Final Center —</option>
                            <option v-for="c in centers" :key="c.id" :value="c.id">{{ c.name }}</option>
                        </select>
                        <ion-icon v-if="item._saving" name="sync-outline" style="color:#1a418c;font-size:16px;animation:spin 1s linear infinite;"></ion-icon>
                        <ion-icon v-else-if="item._saved" name="checkmark-circle" style="color:#1DCC70;font-size:16px;"></ion-icon>
                    </div>
                </div>
            </div>
        </template>

        <!-- ===================== EDIT MODAL ===================== -->
        <div v-if="editTarget" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:flex-end;justify-content:center;">
            <div style="background:#fff;border-radius:20px 20px 0 0;padding:20px;width:100%;max-width:480px;max-height:90vh;overflow-y:auto;">
                <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;">
                    <div style="font-size:15px;font-weight:800;color:#1a418c;">Edit Center</div>
                    <button @click="editTarget=null" style="background:#f1f5f9;border:none;border-radius:50%;width:30px;height:30px;font-size:16px;cursor:pointer;color:#64748b;">✕</button>
                </div>

                <label class="field-label">Centre Name *</label>
                <input v-model="editForm.name" type="text" class="form-control form-control-sm mb-2" placeholder="Centre name" />

                <label class="field-label">Place</label>
                <input v-model="editForm.location" type="text" class="form-control form-control-sm mb-2" placeholder="Place / location" />

                <!-- Coordinator -->
                <label class="field-label">Coordinator</label>
                <div style="position:relative;">
                    <input v-model="editCoordSearch" type="text" class="form-control form-control-sm mb-1"
                        :placeholder="editForm.coordinator_name || 'Search by name or mobile...'"
                        @input="onPersonInput('coord','edit')" @focus="editCoordDrop=true" autocomplete="off" />
                    <div v-if="editCoordDrop && editCoordResults.length"
                        style="position:absolute;left:0;right:0;top:100%;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,0.1);max-height:180px;overflow-y:auto;z-index:200;">
                        <div v-for="m in editCoordResults" :key="m.id" @click="selectPerson('coord','edit',m)"
                            style="padding:10px 12px;cursor:pointer;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px;">
                            <ion-icon name="person-outline" style="color:#1a418c;font-size:15px;flex-shrink:0;"></ion-icon>
                            <div>
                                <div style="font-size:13px;font-weight:700;color:#1e293b;">{{ m.name }}</div>
                                <div style="font-size:11px;color:#64748b;">{{ m.mobile }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="editForm.coordinator_name && !editCoordSearch"
                    style="background:#e8eeff;border-radius:8px;padding:6px 10px;margin-bottom:8px;display:flex;align-items:center;gap:8px;">
                    <ion-icon name="person-circle-outline" style="color:#1a418c;font-size:18px;"></ion-icon>
                    <div style="flex:1;">
                        <div style="font-size:13px;font-weight:700;color:#1a418c;">{{ editForm.coordinator_name }}</div>
                        <div style="font-size:11px;color:#64748b;">{{ editForm.coordinator_mobile }}</div>
                    </div>
                    <span @click="clearPerson('coord','edit')" style="cursor:pointer;color:#94a3b8;font-size:16px;">✕</span>
                </div>
                <label class="field-label">Coordinator Mobile</label>
                <input v-model="editForm.coordinator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <!-- Invigilator -->
                <label class="field-label">Invigilator</label>
                <div style="position:relative;">
                    <input v-model="editInvigSearch" type="text" class="form-control form-control-sm mb-1"
                        :placeholder="editForm.invigilator_name || 'Search by name or mobile...'"
                        @input="onPersonInput('invig','edit')" @focus="editInvigDrop=true" autocomplete="off" />
                    <div v-if="editInvigDrop && editInvigResults.length"
                        style="position:absolute;left:0;right:0;top:100%;background:#fff;border:1px solid #e2e8f0;border-radius:10px;box-shadow:0 4px 16px rgba(0,0,0,0.1);max-height:180px;overflow-y:auto;z-index:200;">
                        <div v-for="m in editInvigResults" :key="m.id" @click="selectPerson('invig','edit',m)"
                            style="padding:10px 12px;cursor:pointer;border-bottom:1px solid #f1f5f9;display:flex;align-items:center;gap:8px;">
                            <ion-icon name="person-outline" style="color:#1a418c;font-size:15px;flex-shrink:0;"></ion-icon>
                            <div>
                                <div style="font-size:13px;font-weight:700;color:#1e293b;">{{ m.name }}</div>
                                <div style="font-size:11px;color:#64748b;">{{ m.mobile }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="editForm.invigilator_name && !editInvigSearch"
                    style="background:#e8f5e9;border-radius:8px;padding:6px 10px;margin-bottom:8px;display:flex;align-items:center;gap:8px;">
                    <ion-icon name="person-circle-outline" style="color:#2e7d32;font-size:18px;"></ion-icon>
                    <div style="flex:1;">
                        <div style="font-size:13px;font-weight:700;color:#2e7d32;">{{ editForm.invigilator_name }}</div>
                        <div style="font-size:11px;color:#64748b;">{{ editForm.invigilator_mobile }}</div>
                    </div>
                    <span @click="clearPerson('invig','edit')" style="cursor:pointer;color:#94a3b8;font-size:16px;">✕</span>
                </div>
                <label class="field-label">Invigilator Mobile</label>
                <input v-model="editForm.invigilator_mobile" type="tel" class="form-control form-control-sm mb-2" placeholder="Mobile number" />

                <div style="display:flex;gap:8px;margin-top:6px;">
                    <button @click="editTarget=null" class="btn btn-sm" style="flex:1;background:#f1f5f9;color:#1e293b;border:none;border-radius:8px;">Cancel</button>
                    <button @click="saveEdit" :disabled="savingEdit || !editForm.name.trim()" class="btn btn-primary btn-sm" style="flex:1;border-radius:8px;">
                        <span v-if="savingEdit" class="spinner-border spinner-border-sm me-1"></span>
                        Save Changes
                    </button>
                </div>
            </div>
        </div>

        <!-- Delete confirm modal -->
        <div v-if="deleteTarget" style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;">
            <div style="background:#fff;border-radius:16px;padding:24px;max-width:320px;width:100%;">
                <div style="font-size:15px;font-weight:700;color:#1e293b;margin-bottom:8px;">Delete Center?</div>
                <div style="font-size:13px;color:#64748b;margin-bottom:16px;">
                    "<b>{{ deleteTarget.name }}</b>" will be removed and all candidate assignments to it will be cleared.
                </div>
                <div style="display:flex;gap:8px;">
                    <button @click="deleteTarget=null" class="btn btn-sm" style="flex:1;background:#f1f5f9;color:#1e293b;border:none;border-radius:8px;">Cancel</button>
                    <button @click="confirmDelete" :disabled="deletingCenter" class="btn btn-sm btn-danger" style="flex:1;border-radius:8px;">
                        <span v-if="deletingCenter" class="spinner-border spinner-border-sm me-1"></span>
                        Delete
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../services/user.service';

export default {
    name: 'QhlsFinalExamCenterMgmt',
    data() {
        return {
            tab: 'centers',
            user_level: 2,
            // Centers list
            centers: [],
            loadingCenters: false,
            // Add form
            newCenter: {
                name: '', location: '',
                coordinator_name: '', coordinator_mobile: '', coordinator_user_id: null,
                invigilator_name: '', invigilator_mobile: '', invigilator_user_id: null,
            },
            addingCenter: false,
            // Add — coordinator search
            addCoordSearch: '', addCoordResults: [], addCoordDrop: false, addCoordTimer: null,
            // Add — invigilator search
            addInvigSearch: '', addInvigResults: [], addInvigDrop: false, addInvigTimer: null,
            // Edit modal
            editTarget: null,
            editForm: {},
            savingEdit: false,
            // Edit — coordinator search
            editCoordSearch: '', editCoordResults: [], editCoordDrop: false, editCoordTimer: null,
            // Edit — invigilator search
            editInvigSearch: '', editInvigResults: [], editInvigDrop: false, editInvigTimer: null,
            // Delete modal
            deleteTarget: null,
            deletingCenter: false,
            // Assign tab
            qualified: [],
            loadingQ: false,
            qualifiedLoaded: false,
            districts: [],
            zones: [],
            qhlsCenters: [],
            f_district: '',
            f_zone: '',
            f_center: '',
        };
    },
    mounted() {
        this.$store.dispatch('setPageHeader', 'QHLS Final Exam Centers');
        const currentUser = this.$store.getters.currentUser;
        this.user_level = parseInt((currentUser && currentUser.user_level) || 2);
        this.loadCenters();
        if (this.user_level === 1) {
            this.loadDistricts();
            this.loadZones();
            this.loadQhlsCenters();
        }
    },
    methods: {
        tabStyle(active) {
            return active ? 'background:#1a418c;color:#fff;' : 'background:#f1f5f9;color:#1a418c;';
        },

        // ---- Person search (shared for coordinator & invigilator, add & edit) ----
        onPersonInput(role, mode) {
            const searchKey = `${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}Search`;
            const timerKey  = `${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}Timer`;
            const search = this[searchKey];
            clearTimeout(this[timerKey]);
            if (search.length < 2) {
                this[`${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}Results`] = [];
                this[`${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}Drop`] = false;
                return;
            }
            this[timerKey] = setTimeout(() => {
                UserService.authPostRequest('search-qhls-coordinator', { query: search }).then(r => {
                    const list = r.data.status === 'success' ? (r.data.data.list || []) : [];
                    this[`${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}Results`] = list;
                    this[`${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}Drop`] = true;
                });
            }, 350);
        },
        selectPerson(role, mode, m) {
            const nameKey   = role === 'coord' ? 'coordinator_name'    : 'invigilator_name';
            const mobileKey = role === 'coord' ? 'coordinator_mobile'  : 'invigilator_mobile';
            const idKey     = role === 'coord' ? 'coordinator_user_id' : 'invigilator_user_id';
            const form = mode === 'add' ? this.newCenter : this.editForm;
            form[nameKey]   = m.name;
            form[mobileKey] = m.mobile;
            form[idKey]     = m.id;
            const prefix = `${mode === 'add' ? 'add' : 'edit'}${role === 'coord' ? 'Coord' : 'Invig'}`;
            this[`${prefix}Search`]  = '';
            this[`${prefix}Results`] = [];
            this[`${prefix}Drop`]    = false;
        },
        clearPerson(role, mode) {
            const nameKey   = role === 'coord' ? 'coordinator_name'    : 'invigilator_name';
            const mobileKey = role === 'coord' ? 'coordinator_mobile'  : 'invigilator_mobile';
            const idKey     = role === 'coord' ? 'coordinator_user_id' : 'invigilator_user_id';
            const form = mode === 'add' ? this.newCenter : this.editForm;
            form[nameKey]   = '';
            form[mobileKey] = '';
            form[idKey]     = null;
        },

        // ---- Centers CRUD ----
        loadCenters() {
            this.loadingCenters = true;
            UserService.authPostRequest('get-qhls-final-exam-centers', {}).then(r => {
                this.loadingCenters = false;
                if (r.data.status === 'success') this.centers = r.data.data.list || [];
            }).catch(() => { this.loadingCenters = false; });
        },
        addCenter() {
            if (!this.newCenter.name.trim()) return;
            this.addingCenter = true;
            UserService.authPostRequest('add-qhls-final-exam-center', {
                name:                 this.newCenter.name.trim(),
                location:             this.newCenter.location.trim(),
                coordinator_name:     this.newCenter.coordinator_name,
                coordinator_mobile:   this.newCenter.coordinator_mobile,
                coordinator_user_id:  this.newCenter.coordinator_user_id,
                invigilator_name:     this.newCenter.invigilator_name,
                invigilator_mobile:   this.newCenter.invigilator_mobile,
                invigilator_user_id:  this.newCenter.invigilator_user_id,
            }).then(r => {
                this.addingCenter = false;
                if (r.data.status === 'success') {
                    this.centers.push(r.data.data.center);
                    this.newCenter = {
                        name: '', location: '',
                        coordinator_name: '', coordinator_mobile: '', coordinator_user_id: null,
                        invigilator_name: '', invigilator_mobile: '', invigilator_user_id: null,
                    };
                    this.addCoordSearch = '';
                    this.addInvigSearch = '';
                }
            }).catch(() => { this.addingCenter = false; });
        },
        openEdit(c) {
            this.editTarget = c;
            this.editForm = {
                id:                  c.id,
                name:                c.name || '',
                location:            c.location || '',
                coordinator_name:    c.coordinator_name || '',
                coordinator_mobile:  c.coordinator_mobile || '',
                coordinator_user_id: c.coordinator_user_id || null,
                invigilator_name:    c.invigilator_name || '',
                invigilator_mobile:  c.invigilator_mobile || '',
                invigilator_user_id: c.invigilator_user_id || null,
            };
            this.editCoordSearch = ''; this.editCoordResults = []; this.editCoordDrop = false;
            this.editInvigSearch = ''; this.editInvigResults = []; this.editInvigDrop = false;
        },
        saveEdit() {
            if (!this.editForm.name.trim()) return;
            this.savingEdit = true;
            UserService.authPostRequest('update-qhls-final-exam-center', {
                id:                  this.editForm.id,
                name:                this.editForm.name.trim(),
                location:            this.editForm.location.trim(),
                coordinator_name:    this.editForm.coordinator_name,
                coordinator_mobile:  this.editForm.coordinator_mobile,
                coordinator_user_id: this.editForm.coordinator_user_id,
                invigilator_name:    this.editForm.invigilator_name,
                invigilator_mobile:  this.editForm.invigilator_mobile,
                invigilator_user_id: this.editForm.invigilator_user_id,
            }).then(r => {
                this.savingEdit = false;
                if (r.data.status === 'success') {
                    const idx = this.centers.findIndex(c => c.id === this.editForm.id);
                    if (idx !== -1) this.centers.splice(idx, 1, r.data.data.center);
                    this.editTarget = null;
                }
            }).catch(() => { this.savingEdit = false; });
        },
        deleteCenter(center) { this.deleteTarget = center; },
        confirmDelete() {
            this.deletingCenter = true;
            const id = this.deleteTarget.id;
            UserService.authPostRequest('delete-qhls-final-exam-center', { id }).then(r => {
                this.deletingCenter = false;
                if (r.data.status === 'success') {
                    this.centers = this.centers.filter(c => c.id !== id);
                    this.deleteTarget = null;
                    this.qualified.forEach(q => { if (q.final_center_id === id) q.final_center_id = null; });
                }
            }).catch(() => { this.deletingCenter = false; });
        },
        // ---- Assign tab ----
        switchToAssign() {
            this.tab = 'assign';
            if (this.user_level !== 1 && !this.qualifiedLoaded) this.loadQualified();
        },
        loadDistricts() {
            UserService.authGetRequest('get-districts').then(r => {
                if (r.data.status === 'success') this.districts = r.data.data.list || r.data.data || [];
            });
        },
        onFDistrictChange() {
            this.f_zone = ''; this.f_center = ''; this.zones = []; this.qhlsCenters = [];
            if (this.f_district) this.loadZones();
        },
        loadZones() {
            const params = this.f_district ? { district_id: this.f_district } : {};
            UserService.authGetRequest('get-zones', params).then(r => {
                if (r.data.status === 'success') this.zones = r.data.data.list || r.data.data || [];
            });
        },
        onFZoneChange() {
            this.f_center = ''; this.qhlsCenters = [];
            if (this.f_zone) this.loadQhlsCenters();
        },
        loadQhlsCenters() {
            const params = {};
            if (this.f_zone) params.zone_id = this.f_zone;
            else if (this.f_district) params.district_id = this.f_district;
            UserService.authGetRequest('get-qhls-centers', params).then(r => {
                if (r.data.status === 'success') this.qhlsCenters = r.data.data.list || r.data.data || [];
            });
        },
        loadQualified() {
            this.loadingQ = true;
            this.qualifiedLoaded = false;
            UserService.authPostRequest('get-qhls-final-qualified-with-centers', {
                district_id: this.f_district || null,
                zone_id:     this.f_zone     || null,
                center_id:   this.f_center   || null,
            }).then(r => {
                this.loadingQ = false;
                this.qualifiedLoaded = true;
                if (r.data.status === 'success') {
                    this.qualified = (r.data.data.list || []).map(q => ({ ...q, _saving: false, _saved: false }));
                }
            }).catch(() => { this.loadingQ = false; this.qualifiedLoaded = true; });
        },
        assignCandidate(item) {
            item._saving = true; item._saved = false;
            UserService.authPostRequest('assign-qhls-final-exam-center', {
                registration_id: item.registration_id,
                center_id:       item.final_center_id || null,
            }).then(r => {
                item._saving = false;
                if (r.data.status === 'success') {
                    item._saved = true;
                    const c = this.centers.find(c => c.id == item.final_center_id);
                    item.final_center_name = c ? c.name : null;
                    setTimeout(() => { item._saved = false; }, 2000);
                }
            }).catch(() => { item._saving = false; });
        },
    },
};
</script>

<style scoped>
@keyframes spin { to { transform: rotate(360deg); } }
.field-label { font-size: 11px; font-weight: 600; color: #64748b; margin-bottom: 3px; display: block; }
</style>
